const Dynpack = require('od-apps/app.dynpack');
const routesOrder = require('od-modules/handlers/dpresults/navigation_order').get();

const indexOfOrder = (item) => {
    const i = routesOrder.indexOf(item);

    return i === -1 ? Infinity : i;
};

const amendProduct = (current) => {
    if (Dynpack.isAmendProductPages(current) && Odigeo.Utils.parseJson(Odigeo.Session.get('amendFromTripSummary'))) {
        Odigeo.Session.remove('amendFromTripSummary');
        return 'booking';
    }

    return false;
};

const navigate = (route, deepLink, bookingId) => {
    if (!route) return;
    if (Odigeo.AB.isDynpackOf2PassengersDesktop && route === 'details') {
        Dynpack.redirectToOF2Page({
            newPage: 'checkout_passengers',
            bookingId,
        });
    } else {
        Odigeo.Router.navigate(route, {
            flowProduct: Odigeo.SessionScope.flowProduct,
            params: deepLink,
            bookingId,
        });
    }
};

module.exports = {
    next(current, deepLink) {
        navigate(amendProduct(current) || this.getNextRoute(current), deepLink);
    },
    prev(current, deepLink) {
        navigate(this.getPreviousRoute(current), deepLink);
    },
    getRoutes() {
        return [...routesOrder];
    },
    getFirstRoute() {
        return this.getRoutes()[0];
    },
    getNextRoute(current) {
        let i = indexOfOrder(current);

        return routesOrder[++i];
    },
    getPreviousRoute(current) {
        let i = indexOfOrder(current);

        return routesOrder[--i];
    },
    getNextUrl() {
        const current = Odigeo.History.getPageNameFromFragment();
        return Odigeo.History.getFragment().replace(current, this.getNextRoute(current));
    },
    isPreviousRoute(route) {
        return indexOfOrder(route) < indexOfOrder(Odigeo.History.getPageNameFromFragment());
    },
    navigate,
};
